import React, { useEffect, useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { CajaProvider } from './contexts/CajaContext'; // NUEVO
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Login from './components/Auth/Login';
import MesasModule from './components/MesasModule';
import PedidosModule from './components/PedidosModule';
import KitchenBarPanel from './components/KitchenBarPanel';
import InventoryManagement from './components/InventoryManagement';
import PagoComponent from './components/PagoComponent';
import DashboardComponent from './components/DashboardComponent'; // Importar el componente Dashboard
import './App.css';
import MesaPedidosComponent from './components/MesaPedidosComponent';
import DetallePedidoComponent from './components/DetallePedidoComponent';
import AgregarProductosComponent from './components/AgregarProductosComponent';
import PedidoDirectoComponent from './components/PedidoDirectoComponent';
import PedidosDirectosListaComponent from './components/PedidosDirectosListaComponent';
import Inventario from './components/Inventario'; // Asegúrate que la ruta sea correcta
import CajaComponent from './components/CajaComponent'; // O simplemente './components/CajaComponent'
import BarrasAdminComponent from './components/BarrasAdminComponent';
import UsuariosAdminComponent from './components/UsuariosAdminComponent';
import ConfiguracionComponent from './components/ConfiguracionComponent';



// Componente para la barra de navegación
const Navbar = () => {
  const { auth, logout } = useContext(AuthContext);
  const [menuAbierto, setMenuAbierto] = useState(false);

  if (!auth) return null;

  const esEncargado = auth.role === 'ENCARGADO';
  const esMozo = auth.role === 'MOZO';
  const esCocinero = auth.role === 'COCINERO';
  const esBartender = auth.role === 'BARTENDER';
  const esCajero = auth.role === 'CAJERO';

  const cerrarMenu = () => setMenuAbierto(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <span className="logo-r">R</span>
      </div>

      {/* Botón hamburguesa — solo visible en móvil/tablet */}
      <button
        className={`navbar-hamburger ${menuAbierto ? 'open' : ''}`}
        onClick={() => setMenuAbierto(!menuAbierto)}
        aria-label="Abrir menú"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Links de navegación + usuario móvil */}
      <div className={`navbar-links ${menuAbierto ? 'open' : ''}`}>
        {(esEncargado || esMozo || esCajero) && (
          <Link to="/mesas" onClick={cerrarMenu}>Mesas</Link>
        )}
        {(esEncargado || esCajero) && (
          <Link to="/caja" onClick={cerrarMenu}>Caja</Link>
        )}
        {(esEncargado || esMozo || esCajero) && (
          <Link to="/pedidos-directos" onClick={cerrarMenu}>Pedidos Directos</Link>
        )}
        {(esEncargado || esCocinero || esBartender) && (
          <Link to="/cocina-barra" onClick={cerrarMenu}>Panel Cocina/Barra</Link>
        )}
        {esEncargado && (
          <Link to="/dashboard" onClick={cerrarMenu}>Dashboard</Link>
        )}
        {esEncargado && (
          <Link to="/inventario" onClick={cerrarMenu}>Inventario</Link>
        )}
        {(esEncargado || esCajero) && (
          <Link to="/configuracion" onClick={cerrarMenu}>Configuración</Link>
        )}
        {esEncargado && (
          <Link to="/usuarios" onClick={cerrarMenu}>Usuarios</Link>
        )}

        {/* Usuario y logout dentro del menú desplegable (solo móvil) */}
        <div className="navbar-user-mobile">
          <span>{auth.user?.nombre || auth.user?.usuario} ({auth.role === 'ENCARGADO' ? 'ADMIN' : auth.role})</span>
          <button onClick={logout} className="logout-btn">Cerrar Sesión</button>
        </div>
      </div>

      {/* Usuario y logout en la derecha (solo desktop) */}
      <div className="navbar-user">
        <span>{auth.user?.nombre || auth.user?.usuario} ({auth.role === 'ENCARGADO' ? 'ADMIN' : auth.role})</span>
        <button onClick={logout} className="logout-btn" title="Cerrar Sesión">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      </div>
    </nav>
  );
};

// Componente principal Dashboard (redireccionamiento)
const Dashboard = () => {
  const { auth } = useContext(AuthContext);

  // Redireccionar según el rol
  if (auth.role === 'ENCARGADO') {
    return <Navigate to="/mesas" />;
  } else if (auth.role === 'MOZO') {
    return <Navigate to="/mesas" />;
  } else if (auth.role === 'COCINERO') {
    return <Navigate to="/cocina-barra" />;
  } else if (auth.role === 'BARTENDER') {
    return <Navigate to="/cocina-barra" />;
  } else if (auth.role === 'CAJERO') { // MODIFICADO: Redirección para el Cajero
    return <Navigate to="/caja" />;
  } else {
    return <div>Bienvenido al sistema</div>;
  }
};

// Componente de página no encontrada
const NotFound = () => {
  return (
    <div className="not-found">
      <h2>404 - Página no encontrada</h2>
      <p>La página que estás buscando no existe.</p>
      <Link to="/">Volver al inicio</Link>
    </div>
  );
};

// Componente principal App
function App() {
  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="logo-container">
          <span className="logo-r">R</span>
        </div>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <CajaProvider> {/* NUEVO: Envolver con CajaProvider */}
        <Router>
          <div className="app-container">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                {/* NUEVO: Ruta para el Módulo de Caja */}
                <Route
                  path="/caja"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'CAJERO']}>
                      <CajaComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Ruta para el DashboardComponent - solo para administradores */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO']}>
                      <DashboardComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Rutas para meseros y administradores */}
                <Route
                  path="/mesas"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <MesasModule />
                    </ProtectedRoute>
                  }
                />

                {/* Ruta principal de pedidos */}
                <Route
                  path="/pedidos"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PedidosModule />
                    </ProtectedRoute>
                  }
                />

                {/* rutas específicas para pedidos de mesas */}
                {/* componente para detalles de pedidos de mesas */}
                <Route
                  path="/mesa/:mesaId/pedidos"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <MesaPedidosComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pedidos/nuevo/:mesaId"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PedidosModule vistaActual="nuevo" />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pedidos/:pedidoId"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <DetallePedidoComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pago/:pedidoId/producto/:detalleId"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PagoComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pedido/:pedidoId/agregar-productos"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <AgregarProductosComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pago/:pedidoId"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PagoComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pago/:pedidoId/seleccionados"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PagoComponent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pedido-directo"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PedidoDirectoComponent />
                    </ProtectedRoute>
                  }
                />


                {/* Nueva ruta para la lista de pedidos directos */}
                <Route
                  path="/pedidos-directos"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'MOZO', 'CAJERO']}>
                      <PedidosDirectosListaComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Rutas para cocineros y administradores */}
                <Route
                  path="/cocina-barra"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'COCINERO', 'BARTENDER']}>
                      <KitchenBarPanel />
                    </ProtectedRoute>
                  }
                />

                {/* Rutas solo para administradores */}
                <Route
                  path="/inventario"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO']}>
                      <Inventario /> {/* Cambiado de InventoryManagement a Inventario */}
                    </ProtectedRoute>
                  }
                />

                {/* Configuración de barras/cocinas — solo ENCARGADO (ruta legacy) */}
                <Route
                  path="/configuracion/barras"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO']}>
                      <BarrasAdminComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Configuración de Impresoras y Sistema — para ENCARGADO y CAJERO */}
                <Route
                  path="/configuracion"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO', 'CAJERO']}>
                      <ConfiguracionComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Gestión de usuarios — solo ENCARGADO */}
                <Route
                  path="/usuarios"
                  element={
                    <ProtectedRoute requiredRoles={['ENCARGADO']}>
                      <UsuariosAdminComponent />
                    </ProtectedRoute>
                  }
                />

                {/* Ruta para página no encontrada */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <footer className="app-footer">
              <p>© 2026 RealPOS - Sistema de Ventas e Inventario</p>
            </footer>
          </div>
        </Router>
      </CajaProvider> {/* NUEVO: Cierre del Provider */}
    </AuthProvider>
  );
}

export default App;